<template>
  <div class="SocialAuth">
    <p class="SocialAuth-label">
      {{ getTypeLabel }} social media account
    </p>
    <div
      :class="{'noText': !showTextLabel}"
      class="SocialAuth-accounts"
    >

      <button
        :class="{'Button-iconOnly': !showTextLabel }"
        class="Button Button--secondary SocialAuth-account SocialAuth--google"
        @click.prevent="socialAuthentication('google')"
      >
        <span
          class="SocialAuth-icon fab fa-google Button-icon"
        />
        <span
          v-if="showTextLabel"
          class="SocialAuth-accountText"
        >Google</span>
      </button>

      <button
        :class="{'Button-iconOnly': !showTextLabel }"
        class="Button Button--secondary SocialAuth-account SocialAuth--linkedin"
        @click.prevent="socialAuthentication('linkedin')"
      >
        <span
          class="SocialAuth-icon fab fa-linkedin Button-icon"
        />
        <span
          v-if="showTextLabel"
          class="SocialAuth-accountText"
        >LinkedIn</span>
      </button>

      <button
        :class="{'Button-iconOnly': !showTextLabel }"
        class="Button Button--secondary SocialAuth-account SocialAuth--apple"
        @click.prevent="socialAuthentication('apple')"
      >
        <span
          class="SocialAuth-icon fab fa-apple Button-icon"
        />
        <span
          v-if="showTextLabel"
          class="SocialAuth-accountText"
        >Apple</span>
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SocialLoginForm',

  props: {
    authType: {
      default: 'login',
      type: String,
    },
    importComment: {
      default: 'Unknown',
      type: String,
    },
    showTextLabel: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      isProcessing: false,
    };
  },
  computed: {
    getTypeLabel() {
      return this.authType === 'login' ? 'Log in with your' : 'You can sign up via your';
    },
  },
  methods: {
    socialAuthentication(provider) {
      this.$gtag.send({
        event: 'social-auth',
        action: `${provider}-${this.authType}-authentication`,
      });
      window.location.href = `/social-auth/${provider}?import_comment=${this.importComment}`;
    },
  },
};
</script>
<style type="text/css" lang="scss">
.SocialAuth-accounts {
  justify-content: center;
}

.SocialAuth-icon {
  margin-right: 4px;
}

.Button.SocialAuth-account {
  margin-bottom: 16px;
}

@supports (display: grid) {
  .SocialAuth-accounts {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-columns: repeat( auto-fit, minmax(128px, 1fr) );
    gap: 16px 16px;
    &.noText{
    grid-template-columns: repeat( auto-fit, minmax(80px, 1fr) );
    }
  }
  .Button.SocialAuth-account {
    margin-left: 0px;
    margin-bottom: 0;
  }
}

.Button-iconOnly {
  .SocialAuth-icon {
    margin: 0;
  }
}

</style>
